// firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// Get these values from Firebase Console:
// Project Settings > General > Your apps > Web app > Config
const firebaseConfig = {
  apiKey: "AIzaSyDf5klGyGHfLCD3Mvf7idUEIGCJ7EKMKH0",
  authDomain: "gcc-law-help.firebaseapp.com",
  projectId: "gcc-law-help",
  storageBucket: "gcc-law-help.firebasestorage.app",
  messagingSenderId: "664338655724",
  appId: "1:664338655724:web:6ddb119b091887a22078c9",
  measurementId: "G-857RCB4NMW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export default app;
